/* eslint-disable */
/* eslint-disable no-tabs */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import _, { cloneDeep, update } from 'lodash';
import {
	PRODUCT_CLASSES,
	PRODUCT_UNITS,
} from '../../../Constants/product.constants';
// eslint-disable-next-line object-curly-newline
import {
	getHigherUnitAndQuantity,
	getUnitConvertedQuantity,
	getUnitConvertedUnit,
	getUnitInLowerUnit,
	imageToBase64,
	unitTypes,
} from '../../../Helpers';
import { notificationServices } from '../../../Services';

const getPriceUnit = (
	variant,
	measurementType,
	productUnit,
	priceKey = 'costPrice'
) => {
	let itemPrice = variant?.[priceKey] || 0;
	let itemUnit = '';
	if (productUnit === 'count') {
		itemUnit = 'count';
		return [itemPrice, itemUnit];
	}
	if (productUnit === 'ltr') {
		itemUnit = 'ltr';
		return [itemPrice, itemUnit];
	}
	// if (productUnit === 'ml') {
	// itemUnit = 'ml';
	// return [itemPrice, itemUnit];
	// }

	if (productUnit === 'floz') {
		// if ((itemPrice * 128) > 1 && Number.isInteger(itemPrice * 128)) {
		if (itemPrice * 128 >= 1) {
			itemUnit = 'gal';
			itemPrice *= 128;
		} else {
			itemUnit = 'floz';
		}
		return [itemPrice, itemUnit];
	}
	if (productUnit === 'oz') {
		if (itemPrice * 16 > 1) {
			itemPrice *= 16;
			itemUnit = 'lbs';
		} else {
			itemUnit = 'oz';
		}
	}
	if (productUnit === 'gram') {
		itemPrice *= 1000;
		itemUnit = 'kg';
	}
	if (productUnit === 'ml') {
		itemPrice *= 1000;
		itemUnit = 'ltr';
	}
	return [itemPrice, itemUnit];
};
const convertPrice = (price, unit) => {
	if (unit === 'lbs') {
		return price / 16;
	}
	if (unit === 'kg' || unit === 'ltr') {
		return price / 1000;
	}
	if (unit === 'gal') {
		return price / 128;
	}
	return price;
};

const getDatainHours = (value, unit = 'HOURS') => {
	let val = null;
	if (unit === 'HOURS') {
		val = value;
	}
	if (unit === 'DAYS') {
		val = value * 24;
	}
	if (unit === 'MONTHS') {
		val = value * 30 * 24;
	}
	return val;
};

const getExpiryValue = (expiry, expiryUnit = 'HOURS') => {
	let val = null;
	if (expiryUnit === 'HOURS' || expiryUnit === null) {
		val = expiry;
	}
	if (expiryUnit === 'DAYS') {
		val = expiry / 24;
	}
	if (expiryUnit === 'MONTHS') {
		val = expiry / (30 * 24);
	}
	return val;
};

const getProductUnit = (itemUnit, measurementType) => {
	if (itemUnit === 'count') {
		if (measurementType === 'US') {
			return 'oz';
		}
		return 'gram';
	}
	return itemUnit;
};
const productConfig = {
	initialState: {
		fields: {
			name: '',
			description: '',
			brand: null,
			category: null,
			subCategory: null,
			tax: 0,
			hsnCode: '',
			defaultLabelId: '',
			priceFixed: false,
			traded: false,
			freshlyPrepared: false,
			freshlyProcured: false,
			skipPrimaryPackaging: false,
			labelledInBulk: false,
			perPieceWeight: '',
			veg: true,
			image: null,
			density: null,
			densityUnit: '',
			productType: '',
			perUnit: '',
			expiry: '',
			expiryUnit: 'HOURS',
			expirySecondary: '',
			expirySecondaryUnit: 'DAYS',
			minTemp: '',
			maxTemp: '',
			productCode: '',
			productClass: PRODUCT_CLASSES.map((productClass) => {
				return {
					...productClass,
					isApplied: false,
				};
			}),
			productUnits: PRODUCT_UNITS?.map((productUnit) => {
				return {
					...productUnit,
					isApplied: false,
				};
			}),
			purchaseUnits: PRODUCT_UNITS?.map((productUnit) => {
				return {
					...productUnit,
					isApplied: false,
				};
			}),
			salesUnit: PRODUCT_UNITS?.map((productUnit) => {
				return {
					...productUnit,
					isApplied: false,
				};
			}),
			subUnitId: null,
			inwardTolerance: null,
			variants: [],
			accompaniments: [],
		},
	},
	mandatoryFields: {
		name: true,
		description: false,
		brand: true,
		category: true,
		subCategory: true,
		tax: true,
		veg: true,
		image: true,
		productClass: true,
		productUnit: true,
		purchaseUnits: false,
		expiry: true,
	},
	newVariant: {
		id: null,
		isEnabled: true,
		displayName: '-',
		clientVariantId: null,
		itemShortcode: null,
		description: null,
		pieces: '1',
		containerWeight: null,
		containerUnit: null,
		minWeight: null,
		maxWeight: null,
		minUnit: null,
		maxUnit: null,
		servingQtyPercentage: null,
		serves: null,
		sellingPrice: null,
		transferPrice: null,
		costPrice: null,
		costPriceUnit: null,
		sellingPriceUnit: null,
		transferPriceUnit: null,
		isDefault: false,
		factorPurchaseUnit: 1,
		packSize: null,
		packSizeUnit: null,
		accompaniments: [],
	},
	serializer: (state, data, products = {}) => {
		const defaultProduct = data.variants.find((variant) => {
			return variant.isDefault;
		});
		const disabledUnits =
			data?.measurement === 'US'
				? ['gram', 'litre', 'ml']
				: ['oz', 'floz'];

		const accompaniments = data?.accompaniments
			? data?.accompaniments.map((accompaniment) => {
				const productWithVariant = Object.values?.(
					products ?? {}
				)?.find(
					(product) =>
						product.ProductVariant &&
						Object.values(product.ProductVariant).some(
							(variant) => variant.id === accompaniment.id
						)
				);
				const variantName =
					productWithVariant?.ProductVariant[accompaniment.id]
						?.displayName;
				return {
					productId: productWithVariant?.id,
					productName: productWithVariant?.productName,
					productImage: productWithVariant?.productImageUrl,
					variantId: accompaniment.id,
					qty: getUnitConvertedQuantity(
						accompaniment?.qty,
						productWithVariant?.unit,
						true,
						true,
						true
					),
					unit: productWithVariant?.unit,
					variantName: variantName,
				};
			})
			: [];
		return update(cloneDeep(state), 'fields', () => {
			const newState = {
				name: data.productName,
				description: data.productDescription,
				tax: data.tax,
				image: data.productImageUrl,
				productCode: data?.clientProductId,
				category: data.categoryId,
				subCategory: data.subCategoryId,
				brand: data.brandId,
				price: defaultProduct ? defaultProduct.price : null,
				density: data?.density,
				densityUnit: data?.densityUnit,
				perUnit: data?.unit === 'floz' ? 'Gal' : 'ltr',
				veg: data.isVeg,
				hsnCode: data?.hsnCode,
				defaultLabelId: data?.defaultLabelId ?? '',
				priceFixed: data?.priceFixed ?? false,
				traded: data?.traded ?? false,
				freshlyPrepared: data?.freshlyPrepared ?? false,
				freshlyProcured: data?.freshlyProcured ?? false,
				skipPrimaryPackaging: !!data?.skipPrimaryPackaging,
				labelledInBulk: !!data?.labelledInBulk,
				perPieceWeight: data?.perPieceWeight ?? '',
				expiry: getExpiryValue(data?.hoursToExpire, data?.expiryUnit),
				expiryUnit: data?.expiryUnit ?? 'HOURS',
				expirySecondary: getExpiryValue(data?.hoursToExpireSecondary, data?.expiryUnitSecondary),
				expirySecondaryUnit: data?.expiryUnitSecondary ?? 'DAYS',
				minTemp: data?.minTemp,
				maxTemp: data?.maxTemp,
				productType: data.productType,
				unit: data.productUnit,
				productUnits: PRODUCT_UNITS?.map((productUnit) => {
					return {
						...productUnit,
						isApplied: data?.unit === productUnit?.id,
					};
				})?.filter((ele) => {
					return !disabledUnits?.includes(ele?.id);
				}),
				purchaseUnits: PRODUCT_UNITS?.map((productUnit) => {
					return {
						...productUnit,
						isApplied: data?.purchaseUnit === productUnit?.id,
					};
				})?.filter((ele) => {
					return !disabledUnits?.includes(ele?.id);
				}),
				salesUnit: PRODUCT_UNITS?.map((productUnit) => {
					return {
						...productUnit,
						isApplied: data?.salesUnit === productUnit?.id,
					};
				})?.filter((ele) => {
					return !disabledUnits?.includes(ele?.id);
				}),
				productClass: PRODUCT_CLASSES.map((productClass) => {
					return {
						...productClass,
						isApplied:
							productClass.id?.toLowerCase() ===
							data.skuType?.toLowerCase(),
					};
				}),
				subUnitId: data?.subUnitId ?? null,
				inwardTolerance: data?.inwardTolerance ?? null,
				accompaniments: accompaniments,
				variants: data?.variants,
			};
			return newState;
		});
	},
	variantSerilizer: (state, products = {}) => {
		const newState = {
			productUnit: state?.unit,
			pieces: state?.pieces in ['', null, '0'] ? '1' : state?.pieces,
			purchaseUnit: state?.purchaseUnit,
			skuTypeVariant: state?.skuType,
			variants: state?.variants.map((currVariant) => {
				const [minWeight, minUnit] = getHigherUnitAndQuantity(
					getProductUnit(state?.unit, state?.measurement),
					currVariant?.minWeight
				);
				const [maxWeight, maxUnit] = getHigherUnitAndQuantity(
					getProductUnit(state?.unit, state?.measurement),
					currVariant?.maxWeight
				);
				const [containerWeight, containerUnit] =
					getHigherUnitAndQuantity(
						getProductUnit(state?.unit, state?.measurement),
						currVariant?.containerWeight
					);
				const [packSize, packSizeUnit] = getHigherUnitAndQuantity(
					state?.unit,
					currVariant?.packSize
				);
				const [costPrice, costPriceUnit] = getPriceUnit(
					currVariant,
					state?.measurement,
					state?.purchaseUnit ?? state?.unit
				);
				const [transferPrice, transferPriceUnit] = getPriceUnit(
					currVariant,
					state?.measurement,
					state?.unit,
					'transferPrice'
				);
				const [sellingPrice, sellingPriceUnit] = getPriceUnit(
					currVariant,
					state?.measurement,
					state?.unit,
					'sellingPrice'
				);
				let itemUnit = state?.unit;
				if (
					itemUnit === 'count' ||
					itemUnit === 'litre' ||
					itemUnit === 'ml' ||
					itemUnit === 'floz'
				) {
					if (state?.measurement === 'US') {
						itemUnit = 'oz';
					} else {
						itemUnit = 'g';
					}
				}
				const accompaniments = currVariant?.accompaniments
					? currVariant?.accompaniments.map((accompaniment) => {
						const productWithVariant = Object.values(
							products
						).find(
							(product) =>
								product.ProductVariant &&
								Object.values(product.ProductVariant).some(
									(variant) =>
										variant?.id === accompaniment?.id
								)
						);
						const variantName =
							productWithVariant?.ProductVariant[
								accompaniment.id
							]?.displayName;
						return {
							productId: productWithVariant?.id,
							productName: productWithVariant?.productName,
							productImage:
								productWithVariant?.productImageUrl,
							variantId: accompaniment.id,
							qty: getUnitConvertedQuantity(
								accompaniment?.qty,
								productWithVariant?.unit,
								true,
								true,
								true
							),
							unit: productWithVariant?.unit,
							variantName: variantName,
						};
					})
					: [];
				return {
					...currVariant,
					accompaniments: accompaniments,
					minWeight,
					minUnit,
					maxWeight,
					maxUnit,
					containerWeight,
					containerUnit,
					costPrice,
					costPriceUnit,
					transferPrice,
					transferPriceUnit,
					sellingPrice,
					sellingPriceUnit,
					packSize,
					packSizeUnit,
					itemShortcode: currVariant?.itemShortcode,
				};
			}),
		};
		return { fields: newState };
	},
	deserializer: (state) => {
		const clonedState = cloneDeep(state);
		const req = {};
		// let productDensity = getUnitConvertedQuantity(
		// clonedState.fields.density,
		// clonedState.fields.densityUnit,
		// true
		// );
		const selectedPurchaseUnit = clonedState?.fields?.purchaseUnits?.reduce(
			(finalUnit, currUnit) => {
				if (currUnit?.isApplied) {
					return currUnit?.id;
				}
				return finalUnit;
			},
			''
		);
		const selectedSalesUnit = clonedState?.fields?.salesUnit?.reduce(
			(finalUnit, currUnit) => {
				if (currUnit?.isApplied) {
					return currUnit?.id;
				}
				return finalUnit;
			},
			''
		);
		const selectedInventoryUnit = clonedState?.fields?.productUnits?.reduce(
			(finalUnit, currUnit) => {
				if (currUnit?.isApplied) {
					return currUnit?.id;
				}
				return finalUnit;
			},
			''
		);
		const accompanimentsData = clonedState?.fields?.accompaniments.map(
			(accompaniment) => {
				const newQty =
					unitTypes?.[accompaniment.unit]?.higherUnitDivisionFactor *
					accompaniment.qty;
				return {
					id: accompaniment.variantId,
					qty: newQty,
				};
			}
		);
		const selectedSkuType = clonedState.fields.productClass.reduce(
			(finalType, currType) => {
				if (currType.isApplied) {
					return currType.id.toUpperCase();
				}
				return finalType;
			},
			''
		);
		req.data = {
			productName: clonedState.fields.name,
			productDescription: clonedState.fields.description,
			brandId: clonedState.fields.brand,
			clientProductId: clonedState.fields.productCode,
			productImageUrl: clonedState.fields.image,
			isVeg: clonedState.fields.veg,
			density: clonedState.fields.density,
			categoryId: clonedState.fields.category,
			subCategoryId: clonedState.fields.subCategory,
			tax: clonedState.fields.tax?.toString(),
			hsnCode: clonedState.fields.hsnCode,
			priceFixed: clonedState.fields.priceFixed ?? false,
			traded: clonedState.fields.traded ?? false,
			freshlyPrepared: clonedState.fields.freshlyPrepared ?? false,
			freshlyProcured: clonedState.fields.freshlyProcured ?? false,
			skipPrimaryPackaging: !!clonedState.fields.skipPrimaryPackaging,
			// Only applies to PRODUCT; sent as false for other SKU types.
			labelledInBulk: selectedSkuType === 'PRODUCT' && !!clonedState.fields.labelledInBulk,
			// Only meaningful for weight-based units; cleared otherwise so a unit switch doesn't leave a stale value.
			perPieceWeight: ['gram', 'oz'].includes(
				clonedState.fields.productUnits?.find((u) => u?.isApplied)?.id
			) && clonedState.fields.perPieceWeight !== '' && clonedState.fields.perPieceWeight != null
				? Number(clonedState.fields.perPieceWeight)
				: null,
			defaultLabelId: clonedState.fields.defaultLabelId
				? Number(clonedState.fields.defaultLabelId)
				: null,
			hoursToExpire: Number(
				getDatainHours(
					clonedState?.fields?.expiry,
					clonedState?.fields?.expiryUnit
				)
			),
			hoursToExpireSecondary: Number(
				getDatainHours(
					clonedState?.fields?.expirySecondary,
					clonedState?.fields?.expirySecondaryUnit
				)
			),
			expiryUnit: clonedState?.fields?.expiryUnit,
			expiryUnitSecondary: clonedState?.fields?.expirySecondaryUnit,
			// minTemp: Number(clonedState?.fields?.minTemp),
			// maxTemp: Number(clonedState?.fields?.maxTemp),
			menuTags: 'Healthy Menu',
			tags: '',
			cost: 0.012,
			unit: clonedState?.fields?.productUnits?.reduce(
				(finalUnit, currUnit) => {
					if (currUnit?.isApplied) {
						return currUnit?.id;
					}
					return finalUnit;
				},
				''
			),
			purchaseUnit: selectedPurchaseUnit || null,
			salesUnit: selectedSalesUnit || null,
			subUnitId:
				selectedInventoryUnit === 'count'
					? clonedState?.fields?.subUnitId ?? null
					: null,
			skuType: selectedSkuType,
			// Inward tolerance only applies to INGREDIENT / PACKAGING / OTHER; send
			// null for others. -1 = no limit, 0 = no tolerance, 1-100 = allowed %.
			inwardTolerance: ['INGREDIENT', 'PACKAGING', 'OTHER'].includes(selectedSkuType)
				? clonedState.fields.inwardTolerance
				: null,
			accompaniments: accompanimentsData,
		};
		return imageToBase64(req.data.productImageUrl).then((base64Image) => {
			req.data.productImageUrl = base64Image;
			return req;
		});
	},
	variantDeserlizer: (state, packSizes = {}, packagingProductIds = {}) => {
		const skuType = state?.fields?.skuType;
		const processedVariants = state.fields.variants.map(
			(currVariant, idx) => {
				let tempVariant = {};
				const weightChecks = ['lbs', 'kg', 'gal', 'ltr'];
				const accompanimentsData =
					state?.fields?.variants?.[idx]?.accompaniments?.map(
						(accompaniment) => {
							const newQty =
								unitTypes?.[accompaniment.unit]
									?.higherUnitDivisionFactor *
								accompaniment.qty;
							return {
								id: accompaniment.variantId,
								qty: newQty,
							};
						}
					) || [];

				// Transform pack sizes from modal format to API format
				const packSizeConfig = (packSizes[idx] || []).map((pack) => ({
					id: typeof pack.id === 'number' ? null : pack.id, // If id is a random number (new pack), set to null
					quantity: pack.quantity,
					packId: pack.boxId,
				}));

				// Get packaging product ID for this variant
				const packagingProductId = packagingProductIds[idx]
					? Number(packagingProductIds[idx])
					: null;

				tempVariant = {
					...tempVariant,
					...currVariant,
					id: currVariant?.id,
					accompaniments: accompanimentsData,
					packSizeConfig: packSizeConfig,
					packagingProductId: packagingProductId,
					itemShortcode: currVariant?.itemShortcode?.toUpperCase(),
					minWeight: weightChecks.includes(currVariant?.minUnit)
						? getUnitInLowerUnit(
							currVariant?.minUnit,
							currVariant?.minWeight ?? 1
						)
						: currVariant?.minWeight ?? 1,
					maxWeight: weightChecks.includes(currVariant?.maxUnit)
						? getUnitInLowerUnit(
							currVariant?.maxUnit,
							currVariant?.maxWeight ?? 1
						)
						: currVariant?.maxWeight ?? 1,
					containerWeight: weightChecks.includes(
						currVariant?.containerUnit
					)
						? String(
							getUnitInLowerUnit(
								currVariant?.containerUnit,
								currVariant?.containerWeight
							)
						)
						: currVariant?.containerWeight,
				};
				tempVariant.size = `size${idx + 1}`;
				tempVariant.costPrice = convertPrice(
					tempVariant?.costPrice,
					tempVariant?.costPriceUnit
				)?.toString();
				tempVariant.packSize = getUnitInLowerUnit(
					tempVariant?.packSizeUnit,
					tempVariant?.packSize
				)?.toString();
				if (skuType !== 'INGREDIENT') {
					tempVariant.transferPrice = convertPrice(
						tempVariant?.transferPrice,
						tempVariant?.transferPriceUnit
					)?.toString();
					tempVariant.sellingPrice = convertPrice(
						tempVariant?.sellingPrice,
						tempVariant?.sellingPriceUnit
					)?.toString();
				} else {
					tempVariant.transferPrice = null;
					tempVariant.sellingPrice = null;
				}
				return tempVariant;
			}
		);
		return processedVariants;
	},

	validator: (state, variant = [], isEdit = false) => {
		// eslint-disable-next-line object-curly-newline
		const {
			image,
			tax,
			brand,
			density,
			category,
			subCategory,
			productClass,
			productUnits,
			expiry,
			purchaseUnits,
			hsnCode,
			productCode,
			name,
		} = state.fields;
		const variants = isEdit
			? variant.fields.variants
			: state.fields.variants;

		// check if image is uploaded or not
		if (!image) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please upload an image for the product',
			});
			return false;
		}

		if (!name) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Product Name is Mandatory',
			});
			return false;
		}
		const unit = productUnits?.reduce((finalUnit, currUnit) => {
			if (currUnit?.isApplied) {
				return currUnit?.id;
			}
			return finalUnit;
		}, '');

		if (unit === 'ml' || unit === 'floz' || unit === 'litre') {
			// eslint-disable-next-line eqeqeq
			if (!density || density <= 0) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Density mandatory for liquid items',
				});
				return false;
			}
		}
		const purchaseUnit = purchaseUnits?.reduce((finalUnit, currUnit) => {
			if (currUnit?.isApplied) {
				return currUnit?.id;
			}
			return finalUnit;
		}, null);
		if (purchaseUnit && purchaseUnit === unit) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Product Unit and Purchase Unit cannot be same.',
			});
			return false;
		}
		// check if tax is within 0-100
		if (tax > 100 || tax < 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Product tax should be within 0-100',
			});
			return false;
		}

		// if (!hsnCode) {
		// 	const isIntermediate = productClass?.some(
		// 		(type) => type.name === 'Intermediate' && type.isApplied === true
		// 	);
		// 	if (!isIntermediate) {
		// 		notificationServices.generateNotification({
		// 			type: 'error',
		// 			message: 'HSN Code is Mandatory',
		// 		});
		// 		return false;
		// 	}
		// }
		if (
			hsnCode &&
			hsnCode.length !== 4 &&
			hsnCode.length !== 6 &&
			hsnCode.length !== 8
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'HSN Code length must be either 4 or 6 or 8 digits.',
			});
			return false;
		}
		// check if brand is selected or not
		if (brand == null || brand === '') {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select a valid Brand',
			});
			return false;
		}

		// check if category is selected or not
		if (category == null || category === '') {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select a valid Category',
			});
			return false;
		}
		// check if sub category is selected or not
		if (subCategory == null || subCategory === '') {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select a valid Sub Category',
			});
			return false;
		}
		// check if product class is selected or not
		const noProductClass = productClass.every((productClassObject) => {
			return !productClassObject.isApplied;
		});
		if (noProductClass) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select a product type',
			});
			return false;
		}
		if (expiry === '' || expiry === null) {
			notificationServices?.generateNotification({
				type: 'error',
				message: 'Expires In is mandatory',
			});
			return false;
		}
		// check if product class is selected or not
		const noProductUnitSelected = productUnits.every(
			(productUnitObject) => {
				return !productUnitObject.isApplied;
			}
		);
		if (noProductUnitSelected) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please select product unit',
			});
			return false;
		}
		if (variants.length === 0) {
			notificationServices?.generateNotification({
				type: 'error',
				message: 'At least one variant is required for the product',
			});
			return false;
		}
		if (variants) {
			const emptyValue = variants.some(
				(variant) =>
					variant?.servingQtyPercentage === '' ||
					variant?.servingQtyPercentage === null
			);
			const emptyMinWeight = variants.some(
				(variant) =>
					variant?.minWeight === '' ||
					variant?.minWeight === null ||
					variant?.maxWeight === '' ||
					variant?.maxWeight === null
			);
			const emptyMaxWeight = variants.some(
				(variant) =>
					variant?.maxWeight === '' ||
					variant?.maxWeight === null
			);

			const displayNames = variants.map((variant) =>
				variant.displayName?.trim().toLowerCase()
			);
			const duplicateName =
				new Set(displayNames).size !== displayNames.length;
			const defaultVariant = variants.every(
				(value) => value?.isDefault === false
			);
			const lowerUnitVariant = variants.find(
				(variant) =>
					(variant?.packSizeUnit === 'ml' ||
						variant?.packSizeUnit === 'g') &&
					variant?.packSize < 1
			);
			const minWeightGreaterThanMaxWeight = variants.some(
				(variant) =>
					parseFloat(variant?.minWeight) >
					parseFloat(variant?.maxWeight)
			);

			const isTransferPriceNull = variants.some(
				(variant) =>
					variant?.transferPrice === '' ||
					variant?.transferPrice === null
			);

			if (duplicateName) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Display Name in variants cannot be same',
				});
				return false;
			}

			const isPackaging = productClass?.some(
				(type) => type.name === 'Packaging' && type.isApplied === true
			);

			if (emptyValue && !isPackaging) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Serving Qty(%) is Mandatory in Varaints',
				});
				return false;
			}
			if (emptyMaxWeight && unit === 'count') {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Tolerance Weight is Mandatory in Varaints',
				});
				return false;
			}
			if (emptyMinWeight && unit === 'count') {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Specified Weight is Mandatory in Varaints',
				});
				return false;
			}
			if (lowerUnitVariant) {
				const unitLabel =
					lowerUnitVariant.packSizeUnit === 'ml' ? 'ml' : 'gram';
				notificationServices.generateNotification({
					type: 'error',
					message: `Pack size can't be less than 1 ${unitLabel}`,
				});
				return false;
			}
			if (defaultVariant) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Please Select Only One Variant as Default',
				});
				return false;
			}
			if (minWeightGreaterThanMaxWeight) {
				notificationServices.generateNotification({
					type: 'error',
					message:
						'Specified Weight cannot be greater than Tolerance Weight in Variant',
				});
				return false;
			}
			if (isTransferPriceNull) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Transfer Price is Mandatory in Variant',
				});
				return false;
			}
		}
		return true;
	},
};

export default productConfig;
